import { ChevronRight } from 'lucide-react';
import React from 'react';

const OptionRow = ({
  isButton = 'false',
  isDelete = 'false',
  buttonName = 'Name',
  name = 'Name',
  onClickHandler,
}) => {
  return (
    <div className="settings-option-row flex items-center justify-between p-2 w-full bg-transparent my-5">
      <span className="settings-option-label text-black font-medium text-xl">{name}</span>

      {isButton === 'true' ? (
        <button
          onClick={onClickHandler}
          className={`settings-option-button settings-action-button px-4 text-xl py-3 rounded-xl font-semibold ${
            isDelete === 'true'
              ? 'bg-black text-red-500'
              : 'bg-white text-purple-400 border'
          }`}
        >
          {buttonName}
        </button>
      ) : (
        <ChevronRight />
      )}
    </div>
  );
};

export default OptionRow;
